import cx from 'classnames';
import { Button, SimpleText, Text, SimpleCallback } from 'platform-components';
import React, { useMemo } from 'react';

import './information-banner.scss';

export enum LESSON_INFORMATION_BANNER_VIEW {
    ACTION = 'action',
    SECONDARY = 'secondary',
}

interface Props {
    action: SimpleCallback;
    buttonTextId: string;
    icon: React.ReactNode;
    mix?: string;
    textId: string;
    view?: LESSON_INFORMATION_BANNER_VIEW;
}

export const LessonInformationBanner = React.memo((props: Props) => {
    const { action, buttonTextId, icon, mix, textId, view = LESSON_INFORMATION_BANNER_VIEW.SECONDARY } = props;

    const buttonView = useMemo(() => {
        switch (view) {
            case LESSON_INFORMATION_BANNER_VIEW.ACTION:
                return Button.VIEW.ACTION;
            case LESSON_INFORMATION_BANNER_VIEW.SECONDARY:
            default:
                return Button.VIEW.SECONDARY;
        }
    }, [view]);

    return (
        <div className={cx('lesson-view__information-banner', mix)}>
            <div className="lesson-view__information-banner-icon">{icon}</div>
            <div className="lesson-view__information-banner-text">
                <Text id={textId} type={Text.TYPE.MARKDOWN} />
            </div>
            <Button className="lesson-view__information-banner-button" onClick={action} view={buttonView}>
                <SimpleText id={buttonTextId} />
            </Button>
        </div>
    );
});
